/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function Minus({ width = "18", height = "5" }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 5" className="svg minus">
			<defs>
				<style
					dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
						__html: '.cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}'
					}}
				/>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<path className="cls-1" d="M2.5 2.5h13" id="Layer_2-2" data-name="Layer 2" />
			</g>
		</svg>
	);
}

Minus.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string
};
